import React from "react";
import propTypes from "prop-types";
import { Link } from "react-router-dom";

export default function Button(props) {
  const className = ["box-border", props.className];
  if (props.isPrimary)
    className.push(
      "bg-black",
      "text-white",
      "hover:bg-white",
      "hover:text-black",
      "border-solid",
      "border-2",
      "border-black"
    );
  if (props.isSecondary)
    className.push("border-solid", "border-2", "border-gray-300");
  if (props.isDisabled) className.push("cursor-not-allowed", "bg-graay-600");
  if (props.isBlock) className.push("w-full");
  if (props.isBlock) className.push("w-full");
  if (props.isDense) {
    className.push("p-3");
  } else {
    className.push("py-3 px-16", "text-lg", "font-semibold");
  }
  if (props.type === "link") {
    if (props.isExternal) {
      return (
        <a
          href={props.href}
          className={className.join(" ")}
          style={props.style}
          target={props.target === "_blank" ? "_blank" : undefined}
          rel={props.target === "_blank" ? "noopener noreferrer" : undefined}
        >
          {props.children}
        </a>
      );
    } else {
      return (
        <Link
          to={props.href}
          className={className.join(" ")}
          style={props.style}
          onClick={props.onClick}
        >
          {props.children}
        </Link>
      );
    }
  }
  if (props.isDisabled) {
    return (
      <button
        disabled
        className={className.join(" ")}
        style={props.style}
        onClick={props.onClick}
      >
        {props.children}
      </button>
    );
  }
  return (
    <button
      className={className.join(" ")}
      style={props.style}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

Button.protTypes = {
  type: propTypes.oneOf(["link", "button"]),
  onClick: propTypes.func,
  target: propTypes.string,
  href: propTypes.string,
  className: propTypes.string,
  isLoading: propTypes.bool,
  isExternal: propTypes.bool,
  isDisabled: propTypes.bool,
  isBlock: propTypes.bool,
  isPrimary: propTypes.bool,
  isSecondary: propTypes.bool,
  isDense: propTypes.bool,
};
